import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, image, url, isEvent = false }) => {
    // Default values
    const siteTitle = "Bridge Brawl 2026";
    const defaultDescription = "18 Bridge Content Creators face off in an epic battle over 2 weeks to claim the prize pool. Watch the legendary Bridge Brawl!";
    const defaultImage = "https://bridgebrawl.sabil.ca/assets/images/social-preview.jpeg";
    const siteUrl = "https://bridgebrawl.sabil.ca";

    const finalTitle = title ? `${title} | ${siteTitle}` : siteTitle;
    const finalDescription = description || defaultDescription;
    const finalImage = image || defaultImage;
    const finalUrl = url ? `${siteUrl}${url}` : siteUrl;

    // Structured Data for Google's "Events" Search Feature
    const eventSchema = {
        "@context": "https://schema.org",
        "@type": "Event",
        "name": "Bridge Brawl 2026",
        "startDate": "2026-03-10T12:00",
        "endDate": "2026-04-02T23:59",
        "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",
        "eventStatus": "https://schema.org/EventScheduled",
        "location": {
            "@type": "VirtualLocation",
            "url": siteUrl
        },
        "image": [finalImage],
        "description": finalDescription,
        "organizer": {
            "@type": "Organization",
            "name": "Sabil Systems Inc.",
            "url": siteUrl
        }
    };

    return (
        <Helmet>
            {/* Standard Metadata */}
            <title>{finalTitle}</title>
            <meta name="description" content={finalDescription} />
            <link rel="canonical" href={finalUrl} />

            {/* Open Graph / Facebook / Discord */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={finalUrl} />
            <meta property="og:title" content={finalTitle} />
            <meta property="og:description" content={finalDescription} />
            <meta property="og:image" content={finalImage} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={finalUrl} />
            <meta name="twitter:title" content={finalTitle} />
            <meta name="twitter:description" content={finalDescription} />
            <meta name="twitter:image" content={finalImage} />

            {/* Inject Event Schema conditionally */}
            {isEvent && (
                <script type="application/ld+json">
                    {JSON.stringify(eventSchema)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;